import { VALIDATION_INVALID_EMAIL_MESSAGE, VALIDATION_REQUIRED_EMAIL_MESSAGE } from 'utils/consts';
import * as yup from 'yup';

export default yup.object().shape({
  email: yup.string().email(VALIDATION_INVALID_EMAIL_MESSAGE).required(VALIDATION_REQUIRED_EMAIL_MESSAGE),
});
